module.exports = __webpack_public_path__ + "img/2000_L.517fee27.png";